/**
 * First-run welcome copy — the single place to edit what a brand-new org sees
 * when the assistant opens. Setup is agent-led: the user's coding agent drives
 * it through the `cofactor-onboarding` skill, so this only explains and hands
 * over the commands.
 */

export const FIRST_RUN_INTRO =
  'Cofactor tests your app end to end: it sets up a sandbox, writes the tests, runs them on a schedule and reports what broke. Setup happens from your coding agent, not on this page.';

export const FIRST_RUN_COMMANDS_LABEL = 'Run these in your terminal:';

export const FIRST_RUN_COMMANDS = [
  'npm install -g @runcofactor/cli',
  'cofactor login',
  'cofactor skill install cofactor-onboarding',
] as const;

export const FIRST_RUN_PROMPT_LABEL = 'Then tell your coding agent:';

export const FIRST_RUN_PROMPT = 'Use the cofactor-onboarding skill to set up Cofactor for this repo';

export const FIRST_RUN_OUTRO = 'Questions about Cofactor? Ask me here.';
